export const fetchAndParseResponse = async (url, options) => {
  try {
    const response = await fetch(url, options);
    const parsedResponse = await parseResponse(response);

    if (response.status !== 200) {
      return {
        response: null,
        error: parsedResponse || 'Unknown status while parsing response',
      };
    }
    return {
      response: parsedResponse,
      error: null,
    };
  } catch (error) {
    return {
      response: null,
      error: error || 'Unknown error while parsing response',
    };
  }
};

export const parseResponse = async response => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.indexOf('application/json') !== -1) {
    try {
      return await response.json();
    } catch (error) {
      // Hack to protect against trying to parse against an empty repsonse
      // An easy way to do this is check for the 'content-length' response header,
      // but FETCH does not allow for this.
      // See https://stackoverflow.com/a/44816592
      return null;
    }
  } else if (contentType && contentType.indexOf('text') !== -1) {
    return await response.text();
  }
  return {};
};
